import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const headingId = (text) =>
  String(text).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const textOf = (children) =>
  Array.isArray(children) ? children.map(textOf).join("") : typeof children === "object" ? textOf(children?.props?.children) : String(children ?? "");

const COMPONENTS = {
  h2: ({ children }) => (
    <h2 id={headingId(textOf(children))} className="display mt-12 mb-4 text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
      {children}
    </h2>
  ),
  h3: ({ children }) => <h3 className="display mt-8 mb-3 text-xl font-bold tracking-tight text-slate-900">{children}</h3>,
  p: ({ children }) => <p className="mt-4 text-[17px] leading-[1.8] text-slate-700">{children}</p>,
  ul: ({ children }) => <ul className="mt-4 space-y-2 pl-5 list-disc marker:text-orange-survey text-[17px] leading-[1.7] text-slate-700">{children}</ul>,
  ol: ({ children }) => <ol className="mt-4 space-y-2 pl-5 list-decimal marker:text-topo marker:font-semibold text-[17px] leading-[1.7] text-slate-700">{children}</ol>,
  strong: ({ children }) => <strong className="font-semibold text-slate-900">{children}</strong>,
  blockquote: ({ children }) => <blockquote className="mt-6 border-l-4 border-orange-survey bg-paper-dark/30 px-5 py-3 text-slate-700">{children}</blockquote>,
  code: ({ children }) => <code className="mono text-[0.9em] bg-paper-dark/50 px-1.5 py-0.5 rounded-sm">{children}</code>,
  table: ({ children }) => (
    <div className="mt-6 overflow-x-auto border border-slate-200">
      <table className="w-full text-left text-sm">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-paper-dark/40">{children}</thead>,
  th: ({ children }) => <th className="p-3 mono text-[10px] tracking-[0.16em] uppercase text-slate-600 whitespace-nowrap">{children}</th>,
  td: ({ children }) => <td className="p-3 border-t border-slate-100 text-slate-700 align-top">{children}</td>,
  a: ({ href = "", children }) =>
    href.startsWith("/") ? (
      <Link to={href} className="text-topo font-semibold underline decoration-orange-survey/50 underline-offset-4 hover:decoration-orange-survey">
        {children}
      </Link>
    ) : (
      <a href={href} target="_blank" rel="noopener noreferrer" className="text-topo font-semibold underline underline-offset-4">
        {children}
      </a>
    ),
};

/** Site-styled markdown renderer (GFM tables, internal links via router). */
export default function Markdown({ content, testid = "markdown-body" }) {
  return (
    <div data-testid={testid}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
